export default __webpack_public_path__ + "static/media/Słowniczek_Sanja.56daabc2.pdf";